<template>
  <lg-finder
    ref="finder"
    :id="this.id"
    :fields="fields"
    title="Busca Status"
    url="/api/status"
    @onSelect="onSelect"
  />
</template>
<script>
import LgFinder from "@/core/components/Inputs/LgFinder.vue";
import ResourceService from "@/core/api/ResourceService";

export default {
  components: { LgFinder },
  props: {
    id: String,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Código",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-2",
          isRowHeader: true,
        },
        {
          key: "descricao",
          label: "Descrição",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-4",
        },
        {
          key: "descricao",
          label: "Descrição",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-6",
        },
        {
          key: "tipoStatus.descricao",
          label: "Tipo Status",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-4",
        },
        {
          key: "situacao",
          label: "Situação",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 col-4",
        },
      ],
    };
  },
  methods: {
    async show() {
      await this.$refs.finder.show();
    },
    
    async showTipoStatus(tipoId) {
      const url = `/api/status/tipo/` + tipoId;
      this.$refs.finder.$service = new ResourceService(url);
      await this.$refs.finder.show();
    },

    async onSelect(item) {
      this.$emit("onSelect", item);
      await this.$bvModal.hide(this.id);
    },
  },
};
</script>
